import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Shell } from "@/components/layout/Shell";
import { ForcePasswordChange } from "@/components/layout/ForcePasswordChange";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Signals from "@/pages/Signals";
import Backtest from "@/pages/Backtest";
import Risk from "@/pages/Risk";
import Journal from "@/pages/Journal";
import Connections from "@/pages/Connections";
import Audit from "@/pages/Audit";
import Security from "@/pages/Security";
import Admin from "@/pages/Admin";
import Setup from "@/pages/Setup";

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-[#848e9c] text-sm" data-testid="auth-loading">Authenticating…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <ForcePasswordChange />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return <Shell>{children}</Shell>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/setup" element={<Setup />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/signals" element={<Protected><Signals /></Protected>} />
            <Route path="/backtest" element={<Protected><Backtest /></Protected>} />
            <Route path="/risk" element={<Protected><Risk /></Protected>} />
            <Route path="/journal" element={<Protected><Journal /></Protected>} />
            <Route path="/connections" element={<Protected><Connections /></Protected>} />
            <Route path="/audit" element={<Protected><Audit /></Protected>} />
            <Route path="/security" element={<Protected><Security /></Protected>} />
            <Route path="/admin" element={<Protected roles={["admin"]}><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#1e2329", border: "1px solid #2b3139", color: "#eaecef", fontSize: 13 } }} />
      </AuthProvider>
    </div>
  );
}

export default App;
